import {Card, Modal} from 'react-bootstrap'
import {KTIcon} from '../../../_metronic/helpers'
import {ViewActionForm} from './components/ViewActionForm'

const ViewActionModal = ({show, showModal, dataActions, setDataActions, onSelectDemande}) => {
  return (
    <>
      <Modal
        size='lg'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog modal-dialog-centered'
        show={show}
        onHide={() => showModal(false)}
        backdrop={true}
        animation={true}
      >
        <div className='modal-content shadow-none'>
          <div className='modal-header'>
            <h5 className='modal-title'>Mes actions</h5>
            <div
              className='btn btn-icon btn-sm btn-light-primary ms-2'
              onClick={() => showModal(false)}
            >
              <KTIcon className='fs-2' iconName='cross' />
            </div>
          </div>
          <div className='modal-body'>
            <ViewActionForm
              dataActions={dataActions}
              setDataActions={setDataActions}
              showModal={showModal}
              onSelectDemande={onSelectDemande}
            />
          </div>
        </div>
      </Modal>
    </>
  )
}
export {ViewActionModal}
